// Navigation des Moduls `quellen` (eager geladen; Quelle UX §2.2–§2.10). Besitzer: Modul quellen.
import { Plug, ShareNetwork, ShieldCheck } from '@phosphor-icons/react';
import { defineMeta } from '@web/registry/define';

export default defineMeta({
  key: 'quellen',
  title: 'Sources & sharing',
  nav: {
    admin: [
      {
        key: 'quellen.all',
        label: 'All sources',
        icon: Plug,
        path: '/sources',
        roles: ['ADM'],
        order: 740,
        area: 'Knowledge',
      },
      {
        key: 'quellen.policies',
        label: 'Source policies',
        icon: ShieldCheck,
        path: '/sources/policies',
        roles: ['ADM'],
        order: 750,
        area: 'Knowledge',
      },
    ],
    ai: [
      {
        key: 'quellen.sharing',
        label: 'Sharing',
        icon: ShareNetwork,
        path: '/sharing',
        roles: ['ALL'],
        order: 50,
        area: 'sidebar',
      },
      {
        key: 'quellen.sources',
        label: 'Sources',
        icon: Plug,
        path: '/sources',
        roles: ['ALL'],
        order: 60,
        area: 'sidebar',
      },
    ],
  },
});
